import { render } from "./NursingHeader.vue?vue&type=template&id=e2d059dc"
import script from "./NursingHeader.vue?vue&type=script&lang=js"
export * from "./NursingHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__